import { IconContent } from '@icons';

export const caretRightFilled: IconContent = {
    sm: '<path d="M4 4.308.465 8H0V0h.465L4 3.692v.616Z" />',
};
